export const NEXT_IMAGE_DEVICE_SIZES = [640, 750, 828, 1080, 1200, 1920, 2048, 3840] as const;
export type NextImageDeviceSizes = Array<(typeof NEXT_IMAGE_DEVICE_SIZES)[number]>;
